import SlickSlider from "slick-slider";

window.$ = window.jQuery;

Drupal.behaviors.gallerySection = {
  attach: function (context) {
    let $gallery = $("section.gallery", context);
    let $showArrows = false;
    let $centerPadding = "80px";
    if ($(".section.gallery.slider").length) {
      $showArrows = true;
      $centerPadding = "100px";
    }

    if ($gallery.length > 0) {
      $(".gallery__slide", $gallery)
        .not(".slick-initialized")
        .slick({
          dots: false,
          arrows: $showArrows,
          prevArrow:
            '<button class="chevron-prev">' +
            Drupal.t("Previous") +
            "</button>",
          nextArrow:
            '<button class="chevron-next">' + Drupal.t("Next") + "</button>",
          centerPadding: $centerPadding,
          centerMode: false,
          variableWidth: true,
          swipeToSlide: true,
          infinite: true,

          responsive: [
            {
              breakpoint: 1100,
              settings: {
                slidesToShow: 1,
                arrows: false,
              },
            },
          ],
        });
      $gallery.addClass("slick-initialized");
    }
  },
};
